import { supabaseConfigured } from "./supabase";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function buildHeaders(session, options = {}, isForm = false) {
  const headers = new Headers(options.headers || {});
  if (!isForm) headers.set("Content-Type", "application/json");
  if (session?.access_token) headers.set("Authorization", `Bearer ${session.access_token}`);
  if (!session && !supabaseConfigured) headers.set("X-Preview-User", "study-buddy-preview");
  return headers;
}

export async function apiFetch(path, session, options = {}) {
  const response = await fetch(`${API}${path}`, { ...options, headers: buildHeaders(session, options, false) });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) { const error = new Error(data.detail || "Request failed. Please try again."); error.status = response.status; throw error; }
  return data;
}

export async function apiUpload(path, session, file, onProgress) {
  // Use XHR so we get upload progress on both desktop and mobile browsers.
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${API}${path}`);
    const headers = buildHeaders(session, {}, true);
    headers.forEach((v, k) => xhr.setRequestHeader(k, v));
    if (onProgress) xhr.upload.onprogress = (e) => { if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100)); };
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText || "{}"); } catch { data = {}; }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.detail || "Upload failed. Please try again."));
    };
    xhr.onerror = () => reject(new Error("Network error during upload."));
    const form = new FormData();
    form.append("file", file);
    xhr.send(form);
  });
}
